// import * as sessionApi from '@/api/sessionApi';
// import cda from './cda';
// import pdf from './pdf';
// import report from './report';
// import watch from './watch';
// import provider from './provider';
// import preferences from './preferences';

// import { setCsrf, setApplicationModel, LoggedOut,LoggedIn } from '@/mutation-types';
// import { RESET_TIMER } from '@/constants/event';

// import {ResumeFsm,NoResumeFsm,LoginFailure,LoginNavigation} from './fsm/messages';
// import * as messages from './fsm/messages';
// import Vue from 'vue';
// import { post } from '@/store/modules/fsm/index';
// import router from '@/router/index';
// import _ from 'lodash';

// import {
//   FEATURES
// } from '@/config';

// let { LoggedIn:LoggedInMessage } = messages;

// const state = {
//   phrData: null,
//   loggedIn: false,
//   sessionId: null,  //TODO: sessionId is not used at the moment
//   csrf: {
//     param: null,
//     token: null
//   }
// };

// const getters = {
//   getCsrf: state => state.csrf,
//   getAllData: state => state.phrData,
//   isLoggedIn: state => state.loggedIn,
//   getSessionId: state => state.sessionId,
//   getUser: state => {
//     return {...state.phrData.user, ...state.phrData.patient};
//   },
//   getTaxonomies: state => {
//     if(!FEATURES.cda_header_providers)
//       return _.pickBy(state.phrData.taxonomies,taxo=>_.some(taxo.npis,npi=>{
//         return state.phrData.npiGroupings[npi];
//       }));
//     else
//       return {...state.phrData.taxonomies};
//   },
//   getProviders: state => {
//     return {...state.phrData.npis};
//   },
//   getPatientRelations: state => {
//     return {...state.phrData.patient.relations}
//   },
// };

// const mutations = {
//   [setCsrf] (state,csrf) {
//     Vue.set(state,'csrf',csrf);
//   },
//   [setApplicationModel] (state,payload) {
//     Vue.set(state,'phrData',payload);
//   },
//   [LoggedOut] (state) {
//     Vue.set(state, 'phrData', null);
//     state.loggedIn = false;
//     state.sessionId = null;
//   },
//   [LoggedIn] (state, payload) {
//     Vue.set(state, 'phrData', payload.data);
//     state.loggedIn = true;
//   },
//   addMeasures (state, {externalMeasures,externalMeasCcdMeasIds,externalMeasCcds}) {
//     Vue.set(state.phrData, 'measures', {...state.phrData.measures,...externalMeasures});
//     Vue.set(state.phrData, 'ccds', {...state.phrData.ccds,...externalMeasCcds});
    
//     let measCcdMeasIds = state.phrData.measCcdMeasIds || [];
//     for (let measCcd in externalMeasCcdMeasIds) {
//       if (measCcdMeasIds[measCcd]) {
//         measCcdMeasIds[measCcd] = _.union(measCcdMeasIds[measCcd],externalMeasCcdMeasIds[measCcd]);
//       } else {
//         measCcdMeasIds[measCcd] = externalMeasCcdMeasIds[measCcd];
//       }
//     }
//     Vue.set(state.phrData, 'measCcdMeasIds', measCcdMeasIds);
    
//   }
// };
// const actions = {
//   updateCsrf({commit},csrf) {
//      commit(setCsrf,csrf);
//   },
//   inlineUpdateApplicationModel({commit},data) {
//     commit(setApplicationModel, data);
//   },
//   updateApplicationModel({commit}) {
//     return new Promise((resolve) => {
//       sessionApi.getAllData()
//       .then((applicationModel) => {
//         commit(setApplicationModel, applicationModel);
//         commit('watch/setExternalMeasuresLoaded',false);
//         resolve();
//       })
//       .catch((err) => {
//         console.error(err);
//       });
//     });
//   },
//   async showLoginPrompt({commit}) {
//     commit(LoggedOut);
//     router.push({name:LoginNavigation})
//   },
//   async getInitialMessage({commit}) {
//     let _message = { message : NoResumeFsm };
//     try {
//       let { data,instance,message,watch:watchValue } = await sessionApi.getInitialMessage(); 
//       if(message && message === 'resumeApplicationMessage'/** && state.loggedIn && state.phrData != null */ ) {
//         commit('watch/setExternalMeasuresLoaded', false);
//         _message = { message: ResumeFsm,data,instance,watch:watchValue };
//       } 
//     }
//     catch(err) {
//       alert(err);
//     }
//     return post(_message);
//   },
//   async login ({commit},{loader,patient,password,LoginPage}) {
//     let _message = {message:LoginFailure};
//     try {
//       let response = await sessionApi.login({patient,password});

//       commit('watch/setExternalMeasuresLoaded', false);
//       Vue.vueEventBus.$emit(RESET_TIMER,{ping:true});
//       _message = { ...response };
//       _message.message = LoggedInMessage;
//     }
//     catch(err) {
//       //TODO: 
//       LoginPage.statusMessage = err;
//       // LoginPage.statusMessage = 'Invalid login';
//     }
//     loader.hide();
//     post(_message);
//   },
//   async logout({commit}) {
//     try {
//       await sessionApi.logout();
//     }
//     catch(err) {
//       text = `error in trying to logout: ${err}`;
//       this.$swal({
//         type: 'error',
//         title: 'Unable to log out',
//         text
//       });
//       throw text;
//     } finally {
//       commit(LoggedOut);
//       commit('cda/clearCda');
//       commit('pdf/clearPdf');
//       commit('report/clearReport');
//       commit('watch/clearAllWatches');
//       //TODO: reset fsm ?
//       window.sessionStorage.clear();
//     }
//   },
//   resetSession({commit, dispatch}) {
//     commit(LoggedOut);
//     // router.push({name:LoginNavigation});
//     commit('cda/clearCda');
//     commit('pdf/clearPdf');
//     commit('report/clearReport');
//     commit('watch/clearAllWatches');
//     //TODO: reset fsm ?
//     window.sessionStorage.clear();
//   },
//   addMeasures({commit}, {externalMeasures,externalMeasCcdMeasIds,externalMeasCcds}) {
//     commit('addMeasures', {externalMeasures,externalMeasCcdMeasIds,externalMeasCcds});
//   } 
// };

// const modules = {
//   cda,
//   pdf,
//   report,
//   watch,
//   provider,
//   preferences
// };

// export default {
//   namespaced: true,
//   state,
//   getters,
//   actions,
//   mutations,
//   modules
// }
import * as sessionApi from '@/api/sessionApi';
import cda from './cda';
import pdf from './pdf';
import report from './report';
import watch from './watch';
import provider from './provider';
import preferences from './preferences';

import { setCsrf, setApplicationModel, LoggedOut, LoggedIn } from '@/mutation-types';
import { RESET_TIMER } from '@/constants/event';

import { ResumeFsm, NoResumeFsm, LoginFailure, LoginNavigation } from './fsm/messages';
import * as messages from './fsm/messages';
import EventBus from '../../event-bus';
import { post } from '@/store/modules/fsm/index';
import router from '@/router/index';
import _ from 'lodash';

// Same dest mapping as router-guard.js (note notification email links).
function resolveDestPath(dest) {
  if (!dest) return null;
  const d = String(dest);
  if (d === "/" || d === "") return "/welcome";
  if (d === "notes") return "/notes";
  if (d === "professional-notes") return "/professional-notes";
  if (d.startsWith("/")) return d;
  return null;
}

import { FEATURES } from '@/config';
import { syncPrivilegesAfterSessionChange } from '@/utils/privilegesSessionSync';
import { usePatientContextStore } from '@/stores/patientContext';
import { chartKey, chartInView, measuresChart } from './measuresChart';
import { chartReportsForGetAllData, useChartReportsStore } from '@/stores/chartReports';
import { chartPdfsForGetAllData, useChartPdfsStore } from '@/stores/chartPdfs';
import { chartCdasForGetAllData, useChartCdasStore } from '@/stores/chartCdas';
import { useChartCdaStagedItemsStore } from '@/stores/chartCdaStagedItems';
import { useSessionStore } from '@/stores/session';
import genders from '@/data/genders';
import suffixes from '@/data/suffixes';
import { STATES, PHONE_TYPES, RELATION_DESCRIPTIONS } from '@/data/referenceLists';
import { isSessionTimeoutError } from '@/api/request';

let { LoggedIn: LoggedInMessage } = messages;

const state = {
  phrData: {
    patient: {}
  },
  is2faVerified: false,
  intendedRoute: null,
  loggedIn: false,
  sessionId: null,  //TODO: sessionId is not used at the moment
  csrf: {
    param: null,
    token: null
  },
  // Tracks whether a user-initiated logout is in progress to suppress timeout alerts
  isLoggingOut: false
};

/** See `getAllData.viewingPatientChart` below. */
function viewingPatientChart() {
  return usePatientContextStore().viewing || useSessionStore().isImpersonating;
}

const getters = {
  getCsrf: state => state.csrf,
  /**
   * The chart currently in view, in the shape 129 components already read.
   *
   * This used to be `state.phrData` — the blob `getAllData` returned, one call
   * that fetched an entire patient record graph. The port decomposed that
   * endpoint, so nothing populates `phrData` any more and every consumer of
   * `allData.patient.externId` (135 call sites) was reading `null`. The
   * bridge then built `/patients/null/allergies`, and the legacy catch-all
   * handlers turned that into an "unexpected snag" alert on almost every action.
   *
   * Serving it from the patient-context store restores all of them at once,
   * without touching a component. `phrData` is still honoured when something
   * has explicitly set it, so anything still committing `setApplicationModel`
   * keeps working while it migrates.
   */
  getAllData: (state) => {
    const model = state.phrData || {};

    if (model.patient && Object.keys(model.patient).length > 0) {
      return model;
    }

    // Overlay, not replace.
    //
    // The blob has two halves and they come from different places now: who you
    // are arrives from `GET /me/bootstrap`, and which chart is open is the
    // SPA's own state. Returning the patient context on its own dropped the
    // user half, so `allData.user.dob` threw on the profile page. Spreading the
    // model first keeps `user`, `manager` and the rest.
    // `user` and `manager` are always present, even before the fetch lands.
    // Call sites reach straight for `allData.user.dob` without checking, so an
    // absent key is a TypeError during the first render rather than a blank
    // field that fills in a moment later.
    //
    // The reference lists ride along because forty-odd forms bind their
    // `<select>` options to `allData.states` / `.phoneTypes` / `.genders` /
    // `.relationDescriptions`. The Yii2 session response used to ship them, and
    // without them every one of those dropdowns renders empty — a form that
    // silently cannot be filled in. They are static enumerations, so they come
    // from the client rather than a per-session round trip.
    return {
      user: {},
      manager: {},
      states: STATES,
      phoneTypes: PHONE_TYPES,
      relationDescriptions: RELATION_DESCRIPTIONS,
      genders,
      suffixes,

      ...model,
      // Another chart's readings are never this chart's: until `addMeasures`
      // has read the chart in view, the vitals grid and graph see none, and
      // `watch/areExternalMeasuresLoaded` reads false so the pages load them
      // (store/modules/measuresChart.js).
      ...(measuresChart(model) !== undefined && measuresChart(model) !== chartInView()
        ? { measures: {}, measCcdMeasIds: {} }
        : {}),
      // The open chart's saved reports (`reports`, `recent.report.ccd`,
      // `ccds`), which pacmny-be shipped in this blob and the Reports page and
      // the PDF save modal's recent choices still read from it.
      ...chartReportsForGetAllData(usePatientContextStore().patient?.id, model.ccds),
      // The open chart's uploaded PDFs and C-CDAs (`pdfs`, `cdas`), the PDF and
      // CDA workbenches' lists, with a flag each when the list could not be read.
      // The C-CDA open on the CDA page (`login/cda` `cdaId`) carries its staged
      // items, the side bar the clinician reviews before Save.
      ...chartPdfsForGetAllData(usePatientContextStore().patient?.id),
      ...chartCdasForGetAllData(usePatientContextStore().patient?.id, state.cda && state.cda.cdaId),
      ...usePatientContextStore().legacyShape,

      // Main's flag (pacmny-be `getAllData.viewingPatientChart`, renamed from
      // `impersonation` in PR #249): the person at the keyboard is in a chart
      // that is not their own. Read from live state rather than the fetched
      // blob, because the chart changes without a refetch; after the spreads,
      // so a stale blob cannot overrule it. Viewing never changes who is
      // acting — `manager` above stays the staff member at the keyboard.
      //
      // Two ways to be there. The ordinary one is a chart opened in the
      // patient context. The other is an act-as token (the dormant RFC 8693
      // exchange, `useSessionStore().isImpersonating`): the session is then
      // the patient's own, so the patient context sees "my chart", yet the
      // human is still the staff member and everything keyed on this flag —
      // the hidden password change, the staff member as sender — must hold.
      viewingPatientChart: viewingPatientChart(),
      // The pre-#249 name, for any reader not yet renamed: it meant the same
      // thing on main.
      impersonation: viewingPatientChart(),
    };
  },
  /**
   * Whether there is a session — asked by `App.vue` to choose the layout.
   *
   * `state.loggedIn` was set by the Yii2 `/session/login` response and nothing
   * sets it now, so this returned false for a fully authenticated user and the
   * app rendered every private page inside `PublicLayout`, without the private
   * navigation chrome. `syncPrivilegesAfterSessionChange` reads it too and was
   * returning early for the same reason.
   *
   * The profile is the signal, not `session.isAuthenticated`. That getter wraps
   * a plain `oidc.isAuthenticated()` call, and the token it reads is a module
   * variable rather than reactive state — so a computed built on it caches
   * whatever it saw first and never re-evaluates. It happened to read true
   * after a staff sign-in and false after a patient's, which is exactly the
   * kind of order-dependent behaviour that is worse than being simply wrong.
   *
   * `session.me` is reactive, and it is only set once `GET /me` has answered.
   * The Vuex flag is still honoured first so an explicit sign-out wins
   * immediately rather than waiting for the profile to clear.
   */
  isLoggedIn: (state) => Boolean(state.loggedIn || useSessionStore().me),
  getSessionId: state => state.sessionId,

  // Every getter below reads a blob that is now assembled asynchronously, so
  // each has to survive being called before it arrives. They used to
  // dereference `state.phrData` unguarded, which is why a component reading
  // `getUser().dob` threw during the first render rather than reading
  // `undefined` and waiting.
  //
  // Main's getUser was `{...user, ...patient}` with `patient` the chart in
  // view, so a chart's fields won. Here `phrData.patient` is empty unless
  // something set the blob explicitly (the chart is the patient context's),
  // so this is the signed-in person: `dob` is the staff member's own. It is
  // not overlaid with the chart, because readers the port adapted take it as
  // the signed-in person (NotePopup's `userid`, NavigationBarTop). Anything
  // that means the PATIENT's identity reads `getAllData().patient` instead
  // (PrePourPrototype, SaveModalInputs' date-of-birth check).
  getUser: (state) => {
    const model = state.phrData || {};

    return { ...(model.user || {}), ...(model.patient || {}) };
  },
  getTaxonomies: (state) => {
    const model = state.phrData || {};
    const taxonomies = model.taxonomies || {};

    if (!FEATURES.cda_header_providers) {
      const groupings = model.npiGroupings || {};

      return _.pickBy(taxonomies, taxo => _.some(taxo.npis, npi => groupings[npi]));
    }

    return { ...taxonomies };
  },
  getProviders: state => ({ ...((state.phrData || {}).npis || {}) }),
  getPatientRelations: (state) => {
    const model = state.phrData || {};

    // The chart lives in the patient context now; the blob's copy is empty.
    return { ...((model.patient || {}).relations || usePatientContextStore().patient?.relations || {}) };
  },
  isLoggingOut: state => state.isLoggingOut
};

const mutations = {
  [setCsrf](state, csrf) {
    state.csrf = csrf;
  },
  [setApplicationModel](state, payload) {
    state.phrData = payload;
  },
  [LoggedOut](state) {
    state.phrData = null;
    state.loggedIn = false;
    state.sessionId = null;
    // clear 2FA state on logout
    state.is2faVerified = false;
    state.intendedRoute = null;
  },
  [LoggedIn](state, payload) {
    state.phrData = payload.data;
    state.loggedIn = true;
  },
  setIsLoggingOut(state, value) {
    state.isLoggingOut = !!value;
  },
  // NEW: mutations for 2FA and intended route
  SET_2FA_VERIFIED(state, val) {
    state.is2faVerified = !!val;
  },
  SET_INTENDED_ROUTE(state, route) {
    state.intendedRoute = route || null;
  },
  /**
   * One chart's readings into the vitals cache (`/data/externalMeasures`).
   *
   * `patientId` is the chart the answer was read for (vitalsBridge). An
   * answer for a chart no longer in view is dropped: a long chart is many
   * cursor pages, and a clinician who moved on meanwhile would otherwise see
   * the previous patient's readings on the new chart. A first answer for a
   * chart replaces the cache rather than merging into another chart's;
   * reloads of the same chart merge, as main's did. A caller that does not
   * say whose readings these are is taken to mean the chart in view
   * (store/modules/measuresChart.js).
   *
   * `ccds` is the code vocabulary (labels by concept id), not readings, so it
   * keeps merging across charts.
   */
  addMeasures(state, { externalMeasures, externalMeasCcdMeasIds, externalMeasCcds, patientId }) {
    if (!state.phrData) return;

    const inView = chartInView();
    const answeredFor = patientId === undefined ? inView : chartKey(patientId);

    if (answeredFor !== inView) return;

    const held = measuresChart(state.phrData);
    const sameChart = held === undefined || held === inView;

    state.phrData.measures = { ...(sameChart ? state.phrData.measures : {}), ...externalMeasures };
    state.phrData.ccds = { ...state.phrData.ccds, ...externalMeasCcds };

    let measCcdMeasIds = { ...((sameChart && state.phrData.measCcdMeasIds) || {}) };
    for (let measCcd in externalMeasCcdMeasIds) {
      const key = String(measCcd);
      measCcdMeasIds[key] = measCcdMeasIds[key]
        ? _.union(measCcdMeasIds[key], externalMeasCcdMeasIds[measCcd])
        : externalMeasCcdMeasIds[measCcd];
    }
    state.phrData.measCcdMeasIds = measCcdMeasIds;
    state.phrData.measuresPatientId = inView;
  }
};

const actions = {
  updateCsrf({ commit }, csrf) {
    commit(setCsrf, csrf);
  },
  inlineUpdateApplicationModel({ commit }, data) {
    commit(setApplicationModel, data);
  },
  // New optional argument to force a full rebuild of the PHR data
  updateApplicationModel({ commit }, opts = {}) {
    const payload = opts && opts.rebuild === true ? { rebuild: true } : null;
    return new Promise((resolve) => {
      sessionApi.getAllData(payload)
        .then(applicationModel => {
          commit(setApplicationModel, applicationModel);
          commit('watch/setExternalMeasuresLoaded', false);
          syncPrivilegesAfterSessionChange();
          // pacmny-be rebuilt the chart's reports, PDFs and C-CDAs into this
          // model; the port reads them per chart and keeps them. So each list
          // is marked stale (kept on screen meanwhile) and re-read, once, the
          // next time something reads it. Not fetched here: a caller would
          // then pay for lists it may never show, and an upload's own reload
          // (FileUpload.vue) would be a second request rather than joining the
          // one re-read.
          useChartReportsStore().invalidate();
          useChartPdfsStore().invalidate();
          useChartCdasStore().invalidate();
          useChartCdaStagedItemsStore().invalidate();
          resolve();
        })
        // Resolve on failure rather than leaving the promise pending. The
        // router guard awaits this before rendering; a rejection that never
        // settles hangs the navigation on a blank page. The application model
        // is a convenience layer — every page also reads the Pinia stores — so
        // continuing without it is the right outcome, and the console keeps
        // the cause.
        .catch(err => {
          console.error(err);
          resolve();
        });
    });
  },
  async showLoginPrompt({ commit }) {
    commit(LoggedOut);
    router.push({ name: LoginNavigation });
  },
  async getInitialMessage({ commit }) {
    let _message = { message: NoResumeFsm };
    try {
      let { data, instance, message, watch: watchValue } = await sessionApi.getInitialMessage();
      if (message && message === 'resumeApplicationMessage') {
        commit('watch/setExternalMeasuresLoaded', false);
        _message = { message: ResumeFsm, data, instance, watch: watchValue };
      }
    } catch (err) {
      if (!isSessionTimeoutError(err)) {
        alert(err);
      }
    }
    await post(_message);

    // New tab: sessionStorage is empty so the router guard may have sent us to /login
    // before the server cookie session is restored. Leave bootstrap/login for welcome.
    if (_message.message === ResumeFsm) {
      commit('SET_2FA_VERIFIED', true);
      const route = router.currentRoute.value;
      const onBootstrapRoute = route.path === '/' || route.path === '/login';
      if (onBootstrapRoute) {
        const intended = resolveDestPath(route.query?.dest) || '/welcome';
        router.replace(intended).catch(() => {});
      }
    }
  },
  async login({ commit }, { loader, patient, password, LoginPage }) {
    let _message = { message: LoginFailure };

    try {
      let response = await sessionApi.login({ patient, password });
      commit('watch/setExternalMeasuresLoaded', false);
      EventBus.emit(RESET_TIMER, { ping: true });
      
      // Commit the login success mutation so that the global auth state is updated
      commit(LoggedIn, { data: response.data }); 

      // Prepare a FSM message indicating login success
      _message = { ...response, message: "LoggedIn" };
      console.log("? Dispatching LoggedIn message:", _message);
      
      // Dispatch the FSM transition (this updates the FSM state)
      await post(_message);

      // After login, require 6-digit auth then redirect to ?dest= if present (else welcome).
      commit('SET_2FA_VERIFIED', false);
      const intended = resolveDestPath(router.currentRoute.value?.query?.dest);
      commit('SET_INTENDED_ROUTE', intended);
      router.push('/sixDigitAuthorization').catch(() => {});
    } catch (err) {
      if (LoginPage) {
        const backendMessage =
          (typeof err === 'string' ? err : null) ||
          err?.response?.data?.message ||
          err?.message ||
          null;
        LoginPage.statusMessage = backendMessage || "Invalid credentials. Please try again.";
      }
      throw err;
    } finally {
      if (loader && typeof loader.hide === "function") {
        loader.hide();
      }
    }
  },

  async logout({ commit }) {
    commit('setIsLoggingOut', true);
    try {
      await sessionApi.logout();
    } catch (err) {
      // Server session may already be expired (e.g. idle timeout); still clear client state.
      console.warn('Logout request failed:', err);
    } finally {
      commit(LoggedOut);
      commit('cda/clearCda');
      commit('pdf/clearPdf');
      commit('report/clearReport');
      commit('watch/clearAllWatches');
      window.sessionStorage.clear();
      commit('setIsLoggingOut', false);
    }
  },
  resetSession({ commit }) {
    commit(LoggedOut);
    commit('cda/clearCda');
    commit('pdf/clearPdf');
    commit('report/clearReport');
    commit('watch/clearAllWatches');
    window.sessionStorage.clear();
  },
  addMeasures({ commit }, { externalMeasures, externalMeasCcdMeasIds, externalMeasCcds, patientId }) {
    commit('addMeasures', { externalMeasures, externalMeasCcdMeasIds, externalMeasCcds, patientId });
  }
};

const modules = {
  cda,
  pdf,
  report,
  watch,
  provider,
  preferences
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules
};
